

const EnquiryNew = () =>{

return(
 <div className="p-6 bg-white rounded shadow-md">
      <div className="max-w-3xl mx-auto border shadow-md p-4">
      <h2 className="text-2xl font-bold mb-4">
        New Quote
      </h2>
      </div>
</div>
    
);

};


export default EnquiryNew;